<script>
    /*
    	DataTaxonomyField.svelte

        note we are not using .value here
    */

    import { onMount } from 'svelte';
    import { getFieldStyle } from '../../common/data-fields.js';

    // TCARE components
    import DataTaxonomyEditor from './DataTaxonomyEditor.svelte';

    // SMUI components
    import Tooltip, { Wrapper } from '@smui/tooltip';
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiPencil, mdiClose, mdiArrowRight, mdiChevronRightBox } from '@mdi/js';
    import { delimitArray, dedupeSimpleArray, shallowArraysEqual } from "../../common/utils.js";


    export let store;               // Search or Service - for the TaxonomyEditor
    export let taxName;             // TCARE_TAX_1, etc.
    export let label;
    export let isEditable;
    export let isOrigDiff;
    export let isNewDiff;
    export let onCopyTaxonomy;
    export let tooltip;
    export let showDiffs;       // bypass the strike-through and highlighting

    $: taxonomyObj = $store.taxonomies[taxName] || null;        // the JS object - not API data
    $: currentKeywords = taxonomyObj ? taxonomyObj.getSelectedKeywords() : [];
    $: formattedKeywords = getFormattedKeywords(currentKeywords);
    $: originalKeywords = [];       // non-formatted array

    $: isDirty = !shallowArraysEqual(originalKeywords, currentKeywords);
    $: fieldStyle = getFieldStyle(isEditable, isOrigDiff, isNewDiff, isDirty, showDiffs);
    $: isShowingEditor = false;

    // set originalValue one time only!
    onMount(() => {
        // console.log('');
        // console.log('DataTaxonomyField onMount');
        // console.log('$store:');
        // console.log($store);
        // console.log('taxonomyObj:');
        // console.log(taxonomyObj);
        // console.log('taxonomyObj.getSelectedKeywords():');
        // console.log(taxonomyObj.getSelectedKeywords());

        //originalKeywords = taxonomyObj.getSelectedKeywords();       // simple array
        originalKeywords = currentKeywords;
    });

    // must also reset the store, not just the keywords array!
    // need to do this after copying from another field also
    const resetValue = () => {
        currentKeywords = [...originalKeywords];
        taxonomyObj.selectKeywordNodes(currentKeywords);            // new tax method 8/24
        $store = $store;
    }

    const getFormattedKeywords = (currentWords) => {
        // console.log('DataTaxonomyField getFormattedKeywords', currentWords);
        return delimitArray(dedupeSimpleArray(currentWords));
    }

    const _onCopyTaxonomy = () => {
        if (onCopyTaxonomy) onCopyTaxonomy(taxName, taxonomyObj);              // call parent function
    }

    // passed to the DataTaxonomyEditor popup dialog
    const onHideEditor = () => {
        isShowingEditor = false;
    }

    // is this even needed? it is a <div> not an <input>
    const onInputFocus = (e) => {
        if (!isEditable) {
            e.target.blur();
        }
    }


</script>

<style>

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="data-field tax-field">
    <div class="label tax-label">
        {label}
    </div>

    <div class="value tax-value">
        <Wrapper>
            <div class="fake-input" on:focus={onInputFocus} style={fieldStyle}>
                {formattedKeywords}
            </div>
            {#if tooltip && tooltip !== ''}
                <Tooltip xPos="start" yPos="above">{tooltip}</Tooltip>
            {/if}
        </Wrapper>
    </div>

    <div class="icons">
        <!-- the "copy to" icon - call parent's function -->
        {#if onCopyTaxonomy}
            {#if currentKeywords && currentKeywords.length > 0}
                <div class="icon" on:click={_onCopyTaxonomy}>
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiChevronRightBox} /></Icon>
                </div>
            {/if}
        {/if}

        {#if isEditable}
            <div class="icon" on:click={() => isShowingEditor = true}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiPencil} /></Icon>
            </div>
        {/if}

        {#if isEditable && isDirty}
            <div class="icon" on:click={() => resetValue()}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>
            </div>
        {/if}
    </div>
</div>

<!-- this will only launch if isShowingEditor is true - DO NOT WRAP INSIDE BOOLEAN -->
<DataTaxonomyEditor {isShowingEditor} {onHideEditor} {taxName} {store} />

